module.exports = __webpack_public_path__ + "static/media/chess-rook-alt.8b7dbf51.svg";